export const SET_TITLE = 'global/setTitle';
export const SET_THEME = 'global/setTheme';
export const ADD_THEME = 'global/addTheme'; /// 主题增删改，将来实现

export const ZOOM_IN = 'global/zoomIn';
export const ZOOM_OUT = 'global/zoomOut';
export const ZOOM_RESET= 'global/zoomReset';

export const MOVE_XY= 'global/moveXY';
export const MOVE_RESET= 'global/moveReset';
export const MOVE_XY_WHEN_ZOOM= 'global/moveXYWhenZoom';
